import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import CleaningService from './Pages/CleaningService.jsx';
import Success from './Pages/Success.jsx';
import Cancel from './Pages/Cancel.jsx';
import TermsOfService from './Pages/TermsOfService.jsx';
import PrivacyPolicy from './Pages/PrivacyPolicy.jsx';
import WeeklyBookings from './Pages/WeeklyBookings.jsx';
import './App.css';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<CleaningService />} />
        <Route path="/success" element={<Success />} />
        <Route path="/cancel" element={<Cancel />} />
        <Route path="/terms" element={<TermsOfService />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/weekly" element={<WeeklyBookings />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
